import { render } from "./ShipmentsEditing.vue?vue&type=template&id=92c4479c&ts=true"
import script from "./ShipmentsEditing.vue?vue&type=script&lang=ts"
export * from "./ShipmentsEditing.vue?vue&type=script&lang=ts"

import "./ShipmentsEditing.vue?vue&type=style&index=0&id=92c4479c&lang=scss"

import exportComponent from "/var/www/html/lmd-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__